<!-- src/components/projects/Panels.vue -->
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <select class="form-control" id="panel-location" v-model="location">
          <option value="">Select a Location</option>
          <option
            v-for="location in locations"
            :key="location.id"
            :value="location.id"
          >
            {{ location.name }}
          </option>
        </select>
      </div>
      <div class="col-md-6">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            id="panel-name"
            placeholder="Enter Panel Name"
            v-model="name"
            @keyup.enter="addPanel"
          />
          <button
            class="btn btn-success"
            @click="addPanel"
            :disabled="!name.trim() || !location"
          >
            <i class="bi bi-plus-circle"></i> Add
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Location</th>
              <th>Panel</th>
              <th style="width: 60px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="panel in panels" :key="panel.id">
              <td>{{ panel.id }}</td>
              <td>
                <select
                  v-if="editingId === panel.id"
                  class="form-control"
                  v-model="editingLocation"
                >
                  <option
                    v-for="location in locations"
                    :key="location.id"
                    :value="location.id"
                  >
                    {{ location.name }}
                  </option>
                </select>
                <span v-else>{{ getLocationName(panel.location) }}</span>
              </td>
              <td>
                <input
                  v-if="editingId === panel.id"
                  v-model="editingName"
                  class="form-control"
                  placeholder="New Name"
                  @keyup.enter="saveEdit(panel.id)"
                />
                <span v-else>{{ panel.name }}</span>
              </td>
              <td>
                <div class="btn-group btn-group-sm">
                  <button
                    class="btn btn-secondary"
                    @click="viewProject(panel)"
                    title="Visualizar"
                  >
                    <i class="bi bi-eye"></i></button
                  ><button
                    v-if="editingId === panel.id"
                    @click="saveEdit(panel.id)"
                    class="btn btn-secondary btn-sm"
                  >
                    <i class="fas fa-save"></i>
                  </button>
                  <button
                    v-else
                    @click="editPanel(panel)"
                    class="btn btn-secondary btn-sm"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                  <button
                    @click="deletePanel(panel.id)"
                    class="btn btn-danger btn-sm"
                  >
                    <i class="far fa-trash-alt"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { useProjectStore } from "@/stores/projectStore";
import { ref, computed } from "vue";
import { useRouter } from "vue-router";

export default {
  props: {
    project: {
      type: Object, // ou String, dependendo do tipo do ID
      required: true,
    },
  },
  setup(props) {
    const store = useProjectStore();
    const router = useRouter();
    const location = ref("");
    const name = ref("");
    const editingId = ref(null);
    const editingLocation = ref("");
    const editingName = ref("");

    const locations = computed(() => store.getAllLocations());
    const panels = computed(() => store.getAllPanels());

    const addPanel = async () => {
      if (!location.value || !name.value.trim()) return;
      await store.createPanel({
        location: location.value,
        name: name.value.trim(),
      });
      location.value = "";
      name.value = "";
    };

    const editPanel = (panel) => {
      editingId.value = panel.id;
      editingLocation.value = panel.location;
      editingName.value = panel.name;
    };

    const saveEdit = async (id) => {
      if (!editingLocation.value || !editingName.value.trim()) return;
      await store.updateLocation(
        id,
        editingLocation.value,
        editingName.value.trim()
      );
      editingId.value = null;
      editingLocation.value = "";
      editingName.value = "";
    };

    const deletePanel = async (id) => {
      try {
        await store.deletePanel(id);
      } catch (error) {
        console.error("Failed to delete panel:", error);
      }
    };

    // Função para buscar o nome do location com base no ID
    const getLocationName = (locationId) => {
      const location = locations.value.find((loc) => loc.id === locationId);
      return location ? location.name : "Unknown Location";
    };

    const viewProject = (panel) => {
      if (props.project) {
        router.push({
          name: "projectEdit",
          params: {
            projectId: props.project.id,
            panelId: panel.id,
          },
        });
      } else {
        console.error("Project data is missing or not yet loaded.");
      }
    };

    return {
      locations,
      panels,
      location,
      name,
      editingId,
      editingLocation,
      editingName,
      addPanel,
      editPanel,
      saveEdit,
      deletePanel,
      getLocationName,
      viewProject,
    };
  },
};
</script>

<style scoped>
.container {
  padding: 20px;
}

.table {
  margin-top: 20px;
}

.form-label {
  font-weight: bold;
}

.text-danger {
  font-size: 0.9em;
}
</style>
